import { createStyles } from '@material-ui/core';
import {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h7,
  h8,
  bodyText,
  smallText,
  tinyText,
  labels,
  siteNames,
  siteNamesMedium,
  monospace,
  subtitle1,
  body1,
  body2,
  caption,
} from '#web-components/styles/text';

const styles = () => createStyles({
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h7,
  h8,
  bodyText,
  smallText,
  tinyText,
  labels,
  siteNames,
  siteNamesMedium,
  monospace,
  subtitle1,
  body1,
  body2,
  caption,
  halfOpacity: {
    opacity: 0.5,
  },
});

export default styles;
